<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/user/robot";
export default {
  name: "",
  components: {
    cTable,
  },
  props: {
    rows: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    console.log("apis :>> ", apis);
  },
  data() {
    return {
      methods: {
        ...apis,
        list: () => {
          return apis.list({ client_id: this.rows.id });
        },
        beforeHandleList({ data }) {
          return data;
        },
      },
      config: {
        rows: this.rows,
        height: 600,
        slot: "div",
        resize: false,
      },
      footer: {
        show: () => false,
      },
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({
                id: row.id,
                client_id: this.$page.config.rows.id,
              });
              data.phones = data.phones;
              this.$page
                .handleRequestMethods(
                  data.id ? "update" : "add",
                  data,
                  true,
                  true
                )
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 500,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              robot_code: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              phones: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "array",
                },
              ],
              enable: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
            },
          },
          grid: [
            { robot_code: 24 },
            { phones: 24 },
            { enable: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              key: "phones",
              name: () => this.$tz("@成员的手机号"),
              placeholder() {
                return this.$tz("@成员的手机号");
              },
              component: "Select",
              bind: {
                "allow-create": true,
                multiple: true,
              },
              methods: {
                list({ field }) {
                  field.options = [];
                  field.options = this.$modal.params.phones.map((t) => {
                    return {
                      value: t,
                      label: t,
                    };
                  });
                },
              },
            },
            {
              name: () => this.$tz("机器人ID"),
              key: "robot_code",
              component: "Input",
              placeholder: () => this.$tz("机器人ID"),
            },
            {
              name: this.$tz("状态"),
              key: "enable",
              component: "Radio",
              placeholder: () => this.$tz("状态"),
              options: [],
              optionsFn: "EnableDisableNumber",
              optionsKey: "",
              bind: {
                border: true,
              },
              default: 1,
            },
            {
              key: "remarks",
              name: () => this.$tz("备注"),
              placeholder() {
                return this.$tz("备注");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 3 },
              },
            },
          ],
        },
      },
      header: {
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            add() {
              this.getModal("add").open({}, function () {
                this.setTitle(this.$tz("新增"));
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("Robot ID"),
          key: "robot_code",
          minWidth: 130,
        },
        {
          name: () => this.$t("@成员的手机号"),
          key: "phones",
          minWidth: 130,
        },
        {
          name: () => this.$t("tip"),
          key: "enable_txt",
          minWidth: 130,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 130,
        },
        {
          name: () => this.$t("operate1"),
          key: "operator_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("Input Time"),
          key: "create_time",
          minWidth: 130,
        },
        {
          name: () => this.$tz("更新时间"),
          key: "update_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("更新"),
              type: "update",
              fnName: "update",
              bind: {
                type: "primary",
              },
            },
            {
              name: () => this.$tz("删除"),
              type: "del",
              fnName: "del",
              bind: {
                type: "delete",
              },
            },
          ],
          methods: {
            update({ row }) {
              this.getModal("add").open(
                {
                  ...row,
                  phones: row.phones.split(",") || [],
                },
                function () {
                  this.setTitle(this.$tz("更新"));
                }
              );
            },
            del() {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    { id: row.id },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>

<style scoped></style>